import React, { useState } from "react";
import "./bottomNavBar.css";
import RedFoxLogo from "../../../images/RED-FOX-LOGO.png";
import ShoppingCartIcon from "../../../images/icons/shopping-cart.png";
import UserIcon from "../../../images/icons/user.png";
import ShoppingList from "../ShoppingList/ShoppingList";

import { Link } from "react-router-dom";

import { useAuth } from "../../../contexts/AuthContext";

import { useOrder } from "../../../contexts/OrderContext";
import UserMenu from "./user-menu/UserMenu";

import InfoPopup from "../InfoPopup/InfoPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faPhone } from "@fortawesome/free-solid-svg-icons";
import MobileToolbar from "./mobile-toolbar/MobileToolbar";

export default function BottomNavBar() {
  const [popups, setPopups] = useState({
    shoppingList: false,
    userMenu: false,
    info: false,
    tools: false,
  });

  function togglePopups(type) {
    setPopups((prev) => {
      return {
        ...prev,
        [type]: !prev[type],
      };
    });
  }

  const { currentUser } = useAuth();
  const { getAllPrices, dropZeros, getLength } = useOrder();
  const { priceAfterDiscounts } = getAllPrices();

  return (
    <>
      <ShoppingList
        open={popups.shoppingList}
        toggle={() => togglePopups("shoppingList")}
      />

      <MobileToolbar isOpen={popups.tools} />

      <div className="bottom-nav">
        <div className="user-part">
          <span className="user-logo" onClick={() => togglePopups("userMenu")}>
            <UserMenu isOpen={popups.userMenu} />
            <img src={UserIcon} alt="" />
          </span>

          {currentUser ? (
            <span className="login-signup-links">
              خوش آمدید {currentUser.name}
            </span>
          ) : (
            <span className="login-signup-links">
              <Link to="/login">ورود</Link>/<Link to="/signup">ثبت نام</Link>
            </span>
          )}
        </div>
        <div
          className="mobile-more-options"
          onClick={() => togglePopups("tools")}
        >
          <FontAwesomeIcon icon={faEllipsis} />
        </div>
        <div className="nav-logo">
          <span className="right-side-text"> من نمیام تو بیا </span>
          <div className="logo">
            <img src={RedFoxLogo} alt="Logo" />
          </div>
          <span className="left-side-text" onClick={() => togglePopups("info")}>
            {" "}
            تماس با ما{" "}
          </span>
        </div>

        <div className="mobile-contact-us" onClick={() => togglePopups("info")}>
          <FontAwesomeIcon icon={faPhone} />
        </div>

        <div className="shopping-list">
          <div className="shopping-list-details">
            <span className="total-price">
              مجموع:{dropZeros(priceAfterDiscounts)} هزار تومان
            </span>
          </div>
          <div
            className="shopping-list-icon"
            onClick={() => togglePopups("shoppingList")}
          >
            <img src={ShoppingCartIcon} alt="" />
            {getLength() !== 0 && (
              <span className="shopping-cart-count">{getLength()}</span>
            )}
          </div>
        </div>
      </div>
      {popups.info && <InfoPopup handleClose={() => togglePopups("info")} />}
    </>
  );
}
